export function formatDate(timestamp) {
  const now = Date.now();
  const then = timestamp * 1000; // Convert Unix timestamp to milliseconds
  const diff = now - then;

  // Handle future timestamps
  if (diff < 0) {
    const currentYear = new Date().getFullYear();
    const timestampYear = new Date(timestamp * 1000).getFullYear();
    const options = {
      weekday: "short",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    if (currentYear !== timestampYear) {
      options.year = "numeric";
    }

    return new Date(timestamp * 1000).toLocaleDateString("en-US", options);
  }

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  // if not the current year display month day and year
  const currentYear = new Date().getFullYear();
  const timestampYear = new Date(timestamp * 1000).getFullYear();
  if (currentYear !== timestampYear) {
    return new Date(timestamp * 1000).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  // if more than 24 hours display month and day
  if (hours > 24) {
    return new Date(timestamp * 1000).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  }

  // if more than 1 hour display hours
  if (hours > 0) {
    return `${hours}h ago`;
  }

  // if more than 1 minute display minutes
  if (minutes > 0) {
    return `${minutes}m ago`;
  }

  // if less than 1 minute display "just now"
  if (seconds >= 0) {
    return "just now";
  }
}

export function daysAgo(timestamp) {
  const now = Date.now();
  const then = timestamp * 1000; // Convert Unix timestamp to milliseconds
  const diff = now - then;
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}
